export const CHANGE_SHOW_THEME_PREVIEW = 'CHANGE_SHOW_THEME_PREVIEW';
export const CHANGE_LAYOUT_TYPE_THEME = 'CHANGE_LAYOUT_TYPE_THEME';
